import Axios from "axios";
import { adminApi } from "../config";

const endpoint = "/subcategories";

export const listAllSubcategories = async (params: any) => {
  try {
    let url = `${endpoint}`;
    const result = await adminApi.get(url, {
      params,
    });
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};

export const listSubcategoriesForForms = async () => {
  try {
    let url = `${endpoint}/for-forms`;
    const result = await adminApi.get(url);
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};

export const getSubcategoryById = async (id: string) => {
  try {
    let url = `${endpoint}/${id}`;
    const result = await adminApi.get(url);
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};

export const createSubcategory = async (data: any) => {
  try {
    let url = `${endpoint}`;
    const result = await adminApi.post(url, data);
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};

export const updateSubcategory = async (
  projectId: string,
  projectData: any
) => {
  try {
    let url = `${endpoint}/${projectId}`;
    const result = await adminApi.put(url, projectData);
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};

export const deleteSubcategory = async (subcategory: string) => {
  try {
    let url = `${endpoint}/${subcategory}`;
    const result = await adminApi.delete(url);
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};
